import { get, post, del } from './API';

export default {
  fetchBookingServices: async () => get('/booking-services'),
  fetchBookingServiceById: async (id) => get('/booking-services', { id }),
  createBookingService: async (service) => post('/booking-services', service),
  updateBookingService: async (service) => post('/booking-services', service),
  deleteBookingService: async (id) => del('/booking-services', { id }),
  uploadBookingServiceImage: async (serviceId, imageData, contentType) => post('/booking-services', {
    action: 'upload_image',
    service_id: serviceId,
    image_data: imageData,
    content_type: contentType,
  }),
  removeBookingServiceImage: async (serviceId) => post('/booking-services', {
    action: 'remove_image',
    service_id: serviceId,
  }),
};
